export default "__VITE_ASSET__CAX5ZIAu__"